import React from 'react';
var openOneTrust = function openOneTrust() {
  var _OneTrust;
  (_OneTrust = window.OneTrust) === null || _OneTrust === void 0 || _OneTrust.ToggleInfoDisplay();
};
export var OneTrustLink = function OneTrustLink(_ref) {
  var title = _ref.title;
  return /*#__PURE__*/React.createElement("div", {
    className: "one-trust-link",
    onClick: openOneTrust
  }, title);
};